import { render, staticRenderFns } from "./fwxy_en.vue?vue&type=template&id=887f66da&scoped=true"
import script from "./fwxy_en.vue?vue&type=script&lang=js"
export * from "./fwxy_en.vue?vue&type=script&lang=js"
import style0 from "./fwxy_en.vue?vue&type=style&index=0&id=887f66da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887f66da",
  null
  
)

export default component.exports